(function() {
  'use strict';

  const CONFIG = {
    modalId: 'gw-stock-fulfilled-iframe',
    checkInterval: 50,
    injectTimeout: 5000,
    disconnectAfterInjection: false
  };

  let hasInjected = false;
  let mutationObserver = null;

  function injectFontsIntoModal(iframe) {
    if (hasInjected) {
      return Promise.resolve(true);
    }

    return new Promise((resolve) => {
      let timeoutId;
      const checkIframeReady = setInterval(() => {
        try {
          const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

          if (iframeDoc && iframeDoc.body) {
            clearInterval(checkIframeReady);
            clearTimeout(timeoutId);

            let fontBasePath = '/assets/';
            try {
              const themeLink = document.querySelector('link[href*="theme.css"]');
              if (themeLink && themeLink.href) {
                fontBasePath = themeLink.href.substring(0, themeLink.href.lastIndexOf('/') + 1);
              } else {
                console.warn('⚠️ Could not detect theme.css, using fallback path:', fontBasePath);
              }
            } catch (e) {
              console.warn('⚠️ Error detecting font path:', e.message);
            }

            const fontStyles = `
              @font-face {
                font-family: 'PP Agrandir';
                src: url('${fontBasePath}PPAgrandir-Regular.woff2') format('woff2'),
                     url('${fontBasePath}PPAgrandir-Regular.woff') format('woff');
                font-weight: 400;
                font-style: normal;
                font-display: swap;
              }

              @font-face {
                font-family: 'PP Agrandir';
                src: url('${fontBasePath}PPAgrandir-Bold.woff2') format('woff2'),
                     url('${fontBasePath}PPAgrandir-Bold.woff') format('woff');
                font-weight: 700;
                font-style: normal;
                font-display: swap;
              }

              @font-face {
                font-family: 'PP Agrandir';
                src: url('${fontBasePath}PPAgrandir-GrandHeavy.woff') format('woff');
                font-weight: 800;
                font-style: normal;
                font-display: swap;
              }

              @font-face {
                font-family: 'PP Agrandir';
                src: url('${fontBasePath}PPAgrandir-GrandLight.woff') format('woff');
                font-weight: 300;
                font-style: normal;
                font-display: swap;
              }

              .modal-container,
              .modal-container * {
                font-family: 'PP Agrandir', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif !important;
              }

              .modal-title {
                font-family: 'PP Agrandir', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif !important;
                font-weight: 700 !important;
              }

              .notification-message,
              .email-input,
              .notify-button,
              .privacy-text,
              .marketing-container-label,
              .channel-selector button {
                font-family: 'PP Agrandir', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif !important;
              }

              .notify-button {
                font-weight: 600 !important;
              }
            `;

            const styleElement = iframeDoc.createElement('style');
            styleElement.setAttribute('data-injected-by', 'kbite-pdp-font-injector');
            styleElement.textContent = fontStyles;
            iframeDoc.head.appendChild(styleElement);

            hasInjected = true;

            setTimeout(() => {
              try {
                const modalTitle = iframeDoc.querySelector('.modal-title');
                if (modalTitle) {
                  const computedStyle = iframeDoc.defaultView.getComputedStyle(modalTitle);
                  const fontFamily = computedStyle.fontFamily;

                  if (!fontFamily.includes('PP Agrandir')) {
                    console.warn('⚠️ Font may not be loading. Check Network tab for font file errors.');
                  }
                }
              } catch (e) {
                console.warn('⚠️ Could not verify font application:', e.message);
              }
            }, 300);

            if (CONFIG.disconnectAfterInjection && mutationObserver) {
              mutationObserver.disconnect();
            }

            resolve(true);
          }
        } catch (error) {
          console.error('❌ Error injecting fonts into PDP modal:', error);
          clearInterval(checkIframeReady);
          resolve(false);
        }
      }, CONFIG.checkInterval);

      timeoutId = setTimeout(() => {
        clearInterval(checkIframeReady);
        console.warn('⚠️ Timeout waiting for iframe content to load');
        resolve(false);
      }, CONFIG.injectTimeout);
    });
  }

  function checkExistingModal() {
    const existingModal = document.getElementById(CONFIG.modalId);

    if (existingModal) {
      injectFontsIntoModal(existingModal);
      return true;
    }

    return false;
  }

  function startModalObserver() {
    mutationObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1 && node.id === CONFIG.modalId) {
            injectFontsIntoModal(node);
            return;
          }

          if (node.nodeType === 1 && node.querySelector) {
            const modalInside = node.querySelector(`#${CONFIG.modalId}`);
            if (modalInside) {
              injectFontsIntoModal(modalInside);
              return;
            }
          }
        }
      }
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function init() {
    const foundExisting = checkExistingModal();

    if (!foundExisting || !CONFIG.disconnectAfterInjection) {
      startModalObserver();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('beforeunload', () => {
    if (mutationObserver) {
      mutationObserver.disconnect();
    }
  });

})();
